export class UserManagementLookups {
    static getAffiliationName(affId: number): string {
        if (affId == 5) {
            return "Clinical Site"
        }
        else if (affId == 2) {
            return "NIH"
        }
        else if (affId == 3) {
            return "EMMES"
        }
        else if (affId == 4) {
            return "ICON"
        }
        else if (affId == 1) {
            return "RTI"
        }
        else if (affId == 6) {
            return "Protocol Working Group Memeber"
        }
        else {
            return "NA"
        }
    }

    static getRequestType(TypeId: number): string {
        if (TypeId == 1) {
            return "Contact Information"
        }
        else if (TypeId == 2) {
            return "Access Request"
        }       
        else {
            return "NA"
        }
    }

    static getDisplayStatus(statusId: number): string {
        if (statusId == 1) {
            return `<div class="pending-block">Pending</div>`
        }
        else if (statusId == 2) {
            return `<div class="approved-block">Approved</div>`
        }
        else if (statusId == 3) {
            return `<div class="denied-block">Denied</div>`
        }
        else {
            return `<div class="unknown-block">Unknown</div>`
        }
    }
}